export function formatTerms(terms: string[]) {
  return terms.map((term: string) => {
    const dateStr = term.split('T')[0]
    const date = new Date(dateStr)
    const monthNames = [
      'Januar',
      'Februar',
      'Mars',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Desember',
    ]
    return {
      value: dateStr,
      label: `${monthNames[date.getMonth()]} ${date.getFullYear()}`,
    }
  })
}
